import { singletonDocIdByName } from '@pkg/sanity-utils/singletonDocId';
import { SINGLETON_DOCUMENT } from '@pkg/config/sanity/singletons';
import { audienceVisibilityFilter, SITE_IDS, type SiteId } from '@pkg/config/sanity/audience';
import type { LOCALE_CODE } from '@pkg/config/languages/localeCodes';
import { pageFields, shallowPageFields } from '~/apis/sanity/queries/partials/pageFields';

/** @deprecated Prefer {@link SiteId} */
export type IndexPageSiteId = SiteId;

export function indexPage(locale: LOCALE_CODE, siteId: SiteId = SITE_IDS.WWW) {
  return indexPageQuery(locale, pageFields, siteId);
}

/**
 * The query to give to the Listener when in Draft Mode, for indexPage.
 * This is because pageBySlug query is too large to listen to, so we must use a stripped back version.
 */
export function indexPageListener(locale: LOCALE_CODE, siteId: SiteId = SITE_IDS.WWW) {
  return indexPageQuery(locale, shallowPageFields, siteId);
}

function homepageSingleton(siteId: SiteId) {
  return siteId === SITE_IDS.BUSINESS
    ? SINGLETON_DOCUMENT.BUSINESS_HOMEPAGE
    : SINGLETON_DOCUMENT.HOMEPAGE;
}

function indexPageQuery(locale: LOCALE_CODE, fields: string, siteId: SiteId) {
  const id = `_id == "${singletonDocIdByName(homepageSingleton(siteId), locale)}"`;
  const audience = audienceVisibilityFilter(siteId);

  return groq`
    {
      "page": *[${id} && ${audience}][0] {
        ${fields}
      },
    }
  `;
}
